/* Socle commun aux coffrets (metafield custom.bundle, alimente par Odoo).
   Utilise par lpb-bundle-cards.js (rendu classique et rendu a l'aveugle).
   Charge avant lui, expose window.LpbBundle. */
(function () {
  var ODOO_IMAGE_BASE = 'https://lepetitballon.odoo.com/fr/image/';

  // Odoo renvoie indifferemment null, false ou la chaine "False" pour un champ vide.
  function clean(value) {
    if (value == null || value === false) return '';
    var text = String(value).trim();
    return text === 'False' || text === 'false' ? '' : text;
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function odooImage(path) {
    var img = clean(path);
    return img ? ODOO_IMAGE_BASE + img : '';
  }

  // Odoo peut renvoyer `url: false` : on evite un lien mort href="false".
  function productUrl(url) {
    var value = clean(url);
    if (!value) return '';
    if (/^(https?:)?\/\//.test(value) || value.charAt(0) === '/') return value;
    return '/products/' + value;
  }

  function parseJsonTag(root, selector) {
    var el = root && root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // Le metafield arrive en tableau, mais d'anciens coffrets sont des objets indexes.
  function read(root) {
    var raw = parseJsonTag(root, '[data-bundle-bottles]');
    var bottles = [];
    if (raw) {
      bottles = Array.isArray(raw)
        ? raw
        : Object.keys(raw).map(function (key) {
            return raw[key];
          });
    }
    return {
      bottles: bottles.filter(Boolean),
      labelColors: parseJsonTag(root, '[data-bundle-label-colors]') || {},
      strings: parseJsonTag(root, '[data-bundle-strings]') || {}
    };
  }

  // Pastilles labels/cultures : couleur d'Odoo, sinon celle du metaobject `label`,
  // sinon pastille blanche bordee (Bio, Raisonnee...).
  function labelPills(attributes, labelColors) {
    return (attributes || [])
      .map(function (attr) {
        var value = clean(attr && attr.value);
        if (!value) return '';

        var bg = clean(attr && attr.color);
        var color = '';
        if (!bg) {
          var known = labelColors[value.toLowerCase()];
          if (known && known.bg) {
            bg = known.bg;
            color = known.text || '';
          }
        }
        if (!bg) {
          return '<span class="lpb-label lpb-label-s lpb-label--white">' + esc(value) + '</span>';
        }
        return (
          '<span class="lpb-label lpb-label-s" style="background-color: ' + esc(bg) +
          '; border: 1px solid ' + esc(bg) + ';' + (color ? ' color: ' + esc(color) + ';' : '') + '">' +
          esc(value) +
          '</span>'
        );
      })
      .filter(Boolean)
      .join('');
  }

  // Bloc domaine (styles de lpb-product-domaine.css), classes de typo au choix de l'appelant.
  function domaine(winery, options) {
    var opts = options || {};
    var data = winery || {};
    var name = clean(data.name);
    var city = clean(data.city);
    var country = clean(data.country);
    if (!name && !city && !country) return '';

    var icon = odooImage(data.img);
    var url = clean(data.url);
    var nameClass = opts.nameClass || 'lpb-link-l';
    var placeClass = opts.placeClass || 'lpb-body-m';
    var place = [city, country].filter(Boolean).join(', ');

    var nameMarkup = '';
    if (name) {
      nameMarkup = url
        ? '<a href="/pages/domaine/' + esc(url) + '" class="' + nameClass + '">' + esc(name) + '</a>'
        : '<span class="' + nameClass + '">' + esc(name) + '</span>';
    }

    return (
      '<div class="lpb-product-header__domaine">' +
      (icon
        ? '<span class="lpb-product-header__domaine-ico" style="background-image: url(\'' + esc(icon) + '\');"></span>'
        : '') +
      '<div class="lpb-product-header__domaine-container">' +
      nameMarkup +
      (place ? '<span class="' + placeClass + '">' + esc(place) + '</span>' : '') +
      '</div>' +
      '</div>'
    );
  }

  // Profil vin : notes Odoo de 1 a 5 -> barres de 20 a 100% (markup de lpb-product-info.css).
  function profileItems(profile, options) {
    var opts = options || {};
    var fields = opts.fields || [];
    var labels = opts.labels || {};
    var labelClass = opts.labelClass || 'lpb-body-m';
    if (!profile) return '';

    var items = fields
      .map(function (field) {
        var raw = clean(profile[field]);
        var value = parseFloat(raw);
        var label = clean(labels[field]);
        if (!raw || !label || isNaN(value) || value <= 0) return null;
        return { label: label, width: Math.max(0, Math.min(100, value * 20)) };
      })
      .filter(Boolean);

    if (opts.limit) items = items.slice(0, opts.limit);
    if (!items.length) return '';

    return items
      .map(function (item) {
        return (
          '<div class="lpb-product-info__profile-item">' +
          '<span class="' + labelClass + '">' + esc(item.label) + '</span>' +
          '<div class="progress-bar"><div class="progress-bar-fill" style="width: ' + item.width + '%;"></div></div>' +
          '</div>'
        );
      })
      .join('');
  }

  // Odoo nomme les vins "Domaine - Cuvee - Appellation - Couleur - Millesime".
  // Quand la fiche affiche deja domaine / couleur / appellation, on ne garde que la cuvee.
  function shortName(bottle) {
    var full = clean(bottle && bottle.name);
    if (!full) return '';

    var winery = clean(bottle.winery && bottle.winery.name).toLowerCase();
    var drop = [clean(bottle.type), clean(bottle.appellation), clean(bottle.region)]
      .filter(Boolean)
      .map(function (value) {
        return value.toLowerCase();
      });

    var parts = full.split(' - ').filter(function (part) {
      var key = part.trim().toLowerCase();
      if (!key) return false;
      if (winery && (key === winery || key.indexOf(winery) !== -1)) return false;
      return drop.indexOf(key) === -1;
    });

    return parts.length ? parts.join(' - ') : full;
  }

  // Texte d'interface : uniquement ce que les locales renvoient (aucun repli en dur).
  function text(strings, key) {
    return clean(strings && strings[key]);
  }

  window.LpbBundle = {
    // Les 9 criteres envoyes par Odoo, dans l'ordre d'affichage. Seuls ceux
    // renseignes (> 0) sont rendus. L'ordre change selon le rendu : historique
    // pour la fiche large, du plus parlant au moins parlant pour les cartes.
    // Les libelles traduits arrivent du snippet lpb-bundle-json (strings.profile).
    PROFILE_FULL: [
      'tannique',
      'boise',
      'fruite',
      'epice',
      'simple',
      'leger',
      'sec',
      'mineralite',
      'tertiare'
    ],
    PROFILE_COMPACT: [
      'fruite',
      'tannique',
      'boise',
      'epice',
      'simple',
      'leger',
      'mineralite',
      'tertiare',
      'sec'
    ],
    clean: clean,
    esc: esc,
    text: text,
    odooImage: odooImage,
    productUrl: productUrl,
    read: read,
    labelPills: labelPills,
    domaine: domaine,
    profileItems: profileItems,
    shortName: shortName
  };
})();
